import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class BlogCategoryTranslation extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get category() {
    return get(this, '_translation.value', '');
  }

  get codeName(): string {
    return get(this, '_blog_category.taxonomyTerms[0].codename', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/BlogCategoryTranslation.model.js